import React, { useState } from 'react'
import "./Links.scss"
import { FaCheck, FaFacebookF, FaInstagram, FaTelegramPlane, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { PiUpload } from "react-icons/pi";
import { SiYoutubeshorts } from 'react-icons/si';
import { RiDeleteBinLine } from 'react-icons/ri';
import { IoIosArrowDown, IoMdCopy } from 'react-icons/io';
import PersonalInfo from '../../../../Components/PersonalInfo/PersonalInfo';
import { Link } from 'react-router-dom';
export default function Links() {
      const [activeRow, setActiveRow] = useState(null);
        const platforms = [
          { name: 'YouTube', icon: <FaYoutube className='platform-icon' style={{ color: 'red' }} /> },
          { name: 'Facebook', icon: <FaFacebookF className='platform-icon' style={{ color: '#3b5998' }} /> },
          { name: 'Shorts', icon: <SiYoutubeshorts className='platform-icon' style={{ color: 'red' }} /> },
          { name: 'WhatsApp', icon: <FaWhatsapp className='platform-icon' style={{ color: '#25D366' }} /> },
          { name: 'Instagram', icon: <FaInstagram className='platform-icon' style={{ color: '#E1306C' }} /> },
          { name: 'Telegram', icon: <FaTelegramPlane className='platform-icon' style={{ color: '#229ED9' }} /> },
        ];
      const [open, setOpen] = useState(null);
        const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };
      const [orders] = useState([
        {
          id: '301555',
          name: 'YouTube',
           icon: <FaYoutube className='platform-icon' style={{ color: 'red' }} /> ,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Register',
        },
        {
          id: '601556',
          name: 'Facebook', 
          icon: <FaFacebookF className='platform-icon' style={{ color: '#3b5998' }} />,
          client: 'Osama alabyaare',
          product: 'E-book',
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Views',
        },
        {
          id: '301555',
           name: 'Shorts',
          icon: <SiYoutubeshorts className='platform-icon' style={{ color: 'red' }} /> ,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Linck click',
        },
            {
          id: '301555',
           name: 'WhatsApp',
            icon: <FaWhatsapp className='platform-icon' style={{ color: '#25D366' }} />,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Register',
        },
            {
          id: '301555',
          name: 'Instagram',
           icon: <FaInstagram className='platform-icon' style={{ color: '#E1306C' }} />,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Linck click',
        }
      ]);
  return (
    <div className='p-3'>
          <div className="headerr">
        <div className="stock-filters">
          <button className="stock-filter ">Information</button>
          <Link to="/dashboard/Client-Orders"  className='no-style-link'> <button className="stock-filter">Orders</button></Link>
                  <Link to="/dashboard/Client-Payments"  className='no-style-link'> <button className="stock-filter">Payments</button></Link>
                           <Link to="/dashboard/Client-Notices"  className='no-style-link'> <button className="stock-filter">Notices</button></Link>
                                    <Link to="/dashboard/Emarketing-products"  className='no-style-link actives'> <button className="stock-filter">E-marketing</button></Link>

        </div>
      
        <div className="search-wrapperr">
          <input
            type="text"
            placeholder="Search by order id"
            className="stock-search"
          />
          <i className="fa-solid fa-magnifying-glass search-icon"></i>
        </div>
      
        <div className="stock-header">
          <input type="date" placeholder="select dates" />
          <div className="stock-actions">
            <button className="stock-btn blue">Filters</button>
            <button className="stock-btn"><PiUpload/>  Export</button>
          </div>
        </div>
      </div>
          <PersonalInfo
  userData={{
    image: "👤", // أو رابط لصورة
    online: true,
    name: "Osama Ali Ali",
    email: "Osama@gmail.com",
    role: "Client +",
  }}
  personalInfo={{
    "Contact Number": "003737737",
    "Gender": "Male",
    "Date of Birth": "1 Jan, 1985",
    "Country": "Morocco",
    "Member Since": "3 March, 2023",
  }}
  performanceInfo={{
    wallet: "EGP35.00",
    totalOrders: 150,
    balance: 50,
    totalPoints: 350,
    
  }}
   Total="Links"
servecis1="Total Orders"
servecis2="Total Points"
/>

          <div className="headerr">
  <div className="stock-filters">
    <Link to="/dashboard/Emarketing-products">
    <button className="stock-filter ">Products</button>
    </Link>

        <Link to="/dashboard/Emarketing-Website">
    <button className="stock-filter  ">Website</button>
    </Link>    
    <Link to="/dashboard/Emarketing-Links">
    <button className="stock-filter actives ">Links</button>
    </Link>
  
  </div>

  <div className="search-wrapper">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
     <span className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                  Filter by date range
                  <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {open === "Status" && (
                    <div className="list-body h">
                      <ul className="list">
                       <li className="check-item">
  <span className="check-circle"></span>
  <span>User ID</span>
</li>

                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Order Completed(24h)</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Order Completed(30d)</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Late Paid</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Active Order</span>
</li>
                      
                      </ul>
                    </div>
                  )}
                </span>
          <button className="stock-btn"><PiUpload/>  Export</button>

    </div>
  </div>
</div>


      {platforms.map((platform, index) => (
     <div key={index} className='link-row  d-flex align-items-center '>
 <div className='d-flex align-items-center'>
  <div className='platform d-flex align-items-center' style={{ minWidth: '150px', gap: '10px' }}>
    {platform.icon}
    <span>{platform.name}</span>
  </div>


   <div className='d-flex align-items-center gap-3'>
              <input type="text" className='link-input' placeholder={`Type your ${platform.name} link`} />
              <button className='crt-btn'>Create</button>
            </div>

 </div>


  <div className='icon-actions d-flex align-items-center' style={{  justifyContent: 'flex-end' }}>
    <RiDeleteBinLine className='action-icon' />
    <IoMdCopy className='action-icon' />
    <IoIosArrowDown className='action-icon' />
  </div>
</div>

      ))}

        <div className="stock-pagination">
        <span>Showing 1-17 of 100</span>
        <div className="pagination-btns">
          <button>{'<'}</button>
          <button className="active">1</button>
          <button>2</button>
          <button>3</button>
          <button>4</button>
          <button>{'>'}</button>
        </div>
      </div>
            
    </div>
  )
}
